import { Controller, useFormContext } from 'react-hook-form';
import { Box, Button, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useMemo, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { DynDadosCadastraisProps } from '..';
import DialogAddEditDadoTerceiro, { ITerceiroForm } from './DialogAddEditDadoTerceiro';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export default function DadosTerceiros({ spec, extras }: DynDadosCadastraisProps) {
    const { control, watch, getValues, setValue } = useFormContext();

    const [openTerceiroModal, setOpenTerceiroModal] = useState<TOpenModalDadosTerceiro>({ open: false });

    const possuiTerceiros = watch(`${spec.name}.possui_terceiros`) === "Sim"
    const terceiros = watch(`${spec.name}.terceiros`) || [];
    const paddingStyle = { paddingLeft: 0, paddingRight: 0 };

    const opcoesRadio = useMemo(() => [
        { value: "Sim", label: "Sim" },
        { value: "Não", label: "Não" },
    ], [])
    return (
        <>
            <Grid container size={{ xs: 12 }} spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <Typography fontWeight={'bold'} variant='h6'>Terceiros aptos a comprar em nome do cooperado</Typography>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Controller
                        name={`${spec.name}.possui_terceiros`}
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error } }) => (
                            <FormControl {...field}>
                                <FormLabel id="possui_terceiros">Possui terceiros?</FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="Possui terceiros?"
                                    value={getValues(`${spec.name}.possui_terceiros`)}
                                    onChange={(e) => field.onChange(e.target.checked)}
                                >
                                    {
                                        opcoesRadio.map((opcao, index) => (
                                            <FormControlLabel key={index} value={opcao.value} control={<Radio />} label={opcao.label} />
                                        ))
                                    }
                                </RadioGroup>
                                <FormHelperText error>{error ? error.message : ""}</FormHelperText>
                            </FormControl>
                        )}
                    />
                </Grid>
                {
                    possuiTerceiros && terceiros.length > 0 &&
                    <>
                        <Grid size={{ xs: 12 }}>
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={paddingStyle}>
                                                <b>Nome/CPF</b>
                                            </TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {terceiros.map((item: ITerceiroForm, index: number) => (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <Controller
                                                    name={`${spec.name}.terceiros[${index}]`}
                                                    control={control}
                                                    rules={{ required: "Campo obrigatório" }}
                                                    render={({ field, fieldState: { error, invalid } }) => (
                                                        <TableCell sx={{ ...paddingStyle, color: invalid ? 'red' : 'inherit' }}>
                                                            {item.nome || item.cpf} {invalid && "Campo obrigatório"}
                                                        </TableCell>
                                                    )}
                                                />
                                                <TableCell sx={paddingStyle}>
                                                    <Box
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="flex-end"
                                                    >
                                                        <IconButton
                                                            aria-label="edit"
                                                            onClick={() => {
                                                                setOpenTerceiroModal({ open: true, index });
                                                            }}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                        <IconButton
                                                            aria-label="delete"
                                                            onClick={() => {
                                                                const novosTerceiros = terceiros.filter((_: any, i: number) => i !== index);
                                                                setValue(`${spec.name}.terceiros`, novosTerceiros);
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </>
                }
                {
                    possuiTerceiros &&
                    <Grid size={{ xs: 12 }}>
                        <Controller
                            name={`${spec.name}.terceiros`}
                            control={control}
                            rules={{ required: "Campo obrigatório" }}
                            render={({ field, fieldState: { error, invalid } }) => (
                                <>
                                    <Button
                                        variant="outlined"
                                        color={error ? 'error' : 'primary'}
                                        startIcon={<AddIcon />}
                                        onClick={() => setOpenTerceiroModal({ open: true })}
                                    >
                                        Adicionar Pessoa
                                    </Button>
                                    <FormHelperText error>{invalid && error ? error.message : ""}</FormHelperText>
                                </>
                            )}
                        />

                    </Grid>
                }
            </Grid>
            {
                openTerceiroModal.open &&
                <DialogAddEditDadoTerceiro
                    open={openTerceiroModal.open}
                    onClose={() => setOpenTerceiroModal({ open: false })}
                    index={openTerceiroModal.index}
                />
            }
        </>
    )
}

export type TOpenModalDadosTerceiro = {
    open: boolean;
    index?: number;
}
